import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const STORAGE_PREFIX = "ff_";

// Feature flags are off by default. Enable for the tab session by visiting any URL with ?<flag>=true,
// disable again with ?<flag>=false. The value is kept in sessionStorage so it survives in-app navigation
// where the query param would otherwise be dropped.
export function useFeatureFlag(flag: string): boolean {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const key = `${STORAGE_PREFIX}${flag}`;
    const param = searchParams.get(flag);

    if (param === "true") {
      sessionStorage.setItem(key, "true");
    } else if (param === "false") {
      sessionStorage.removeItem(key);
    }

    return sessionStorage.getItem(key) === "true";
  }, [searchParams, flag]);
}
